module.exports = __webpack_public_path__ + "static/media/arrow-left.bdea8807.svg";